/*
 * Copyright (c) 2021, 2022 Tropyc Stoic (38c316a1b8d7188d059c273d892b723b)
 *
 * Permission to use, copy, modify, and distribute this software for any
 * purpose with or without fee is hereby granted, provided that the above
 * copyright notice and this permission notice appear in all copies.
 *
 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
 * WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
 * ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
 * WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
 * ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
 * OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 */
import { useState } from 'react';
import { ethers, BigNumber} from 'ethers'
import reBurnProtocol from './artifacts/contracts/reBurnProtocol.sol/reBurnProtocol.json'

function BurnSwap(props) {
    const {web3, seedAddress} = props;

    const [burnInfo, setBurnInfo] = useState({
        amount: "0",
        tokens: ""
    });

    function handleInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;
        console.log("name " + name+ " " + value);
//        burnInfo[name] = value;
        setBurnInfo({[name]: value})
    }

    async function burn(event) {
        event.preventDefault();
        const signer = web3.getSigner()
        const protocol = new ethers.Contract(seedAddress, reBurnProtocol.abi, signer)
        try{
            // loading = true;
            const addresses = burnInfo.tokens.split(/\r?\n/);

            const amount = BigNumber.from(burnInfo.amount).mul(BigNumber.from(10).pow(18)) //we know the contract has 18 digits
            protocol.burnFor(amount, addresses);
            // loading = false;
        } catch (e) {
            // loading = false;
            //ignore
            console.log(e);
        }
    }

    return (
        <form className="row g-3" onSubmit={burn}>
          <div className="col-md-6">
            <label htmlFor="amount" className="form-label">Amount you want to burn</label>
            <input type="text" className="form-control" id="amount" name="amount" value={burnInfo.amount} onChange={handleInputChange}/>
          </div>
          <div className="col-md-6">
          </div>
          <div className="col-12">
            <label htmlFor="tokens" className="form-label">Tokens you want to receive (add one token address per line)</label>
            <textarea className="form-control" id="tokens" rows="10" name="tokens" value={burnInfo.tokens} onChange={handleInputChange}></textarea>
          </div>
          <div className="col-12">
            <button type="submit" className="btn btn-primary">Swap tokens</button>
          </div>
        </form>
    );
}

export default BurnSwap;